import { Button } from "components";

import { useIntl } from "react-intl";
import { RangePicker } from "components/RangePicker";

import { ReactDatePickerProps } from "react-datepicker";

import "./FilterWithDateForm.scss";

interface FilterWithDateFormProps extends ReactDatePickerProps {
  onClickFilter?: () => void;
}

export const FilterWithDateForm = ({
  startDate,
  endDate,
  onChange,
  onClickFilter,
  placeholderText,
}: FilterWithDateFormProps) => {
  const { formatMessage } = useIntl();
  const today = new Date();  // Get today's date
  return (
    <div className="filter-with-date">
      <div className="form">
        <RangePicker
          placeholderText={placeholderText}
          className="form-range-picker"
          startDate={startDate}
          endDate={endDate}
          onChange={onChange}
          maxDate={today}  // Restrict date selection up to today
          
        />
        <Button className="form__button" onClick={onClickFilter}>
          {formatMessage({
            id: "filter-with-date-form.button",
            defaultMessage: "_filter_",
          })}
        </Button>
      </div>
    </div>
  );
};
